import { ButtonProps } from '@bamboohr/fabric';

export interface DependentBlankStateProps {
    onClick: ButtonProps['onClick'];
    canAdd: boolean;
}

export const DEPENDENT_BLANK_TITLE = $.__('No dependents have been added for this employee.');
export const ADD_DEPENDENT = $.__('Add Dependent');
